import { Action } from '@ngrx/store';
import { PermissionDto, RoleDto, RoleManagementPreload } from '@clearing-hub/common';
import { ChangeApplicationPayload } from '../../model/ChangeApplicationPayload';
// import { Role } from '../../model/Role';

export enum RoleActionTypes {
  InitPermissions = 'InitPermissions',
  AddRole = 'AddRole',
  DeleteRole = 'DeleteRole',
  UpdateRole = 'UpdateRole',
  ChangeApplication = 'ChangeApplication',
  AddPermissionToRole = 'AddPermissionToRole',
  RemovePermissionFromRole = 'RemovePermissionFromRole'
}

export class InitPermissions implements Action {
  readonly type = RoleActionTypes.InitPermissions;

  constructor(public payload: RoleManagementPreload) {
  }
}

export class ChangeApplication implements Action {
  readonly type = RoleActionTypes.ChangeApplication;

  constructor(public payload: ChangeApplicationPayload) {
  }
}

export class AddRole implements Action {
  readonly type = RoleActionTypes.AddRole;

  constructor(public payload: RoleDto) {
  }
}

export class DeleteRole implements Action {
  readonly type = RoleActionTypes.DeleteRole;

  constructor(public payload: number) {
  }
}

export class UpdateRole implements Action {
  readonly type = RoleActionTypes.UpdateRole;

  constructor(public payload: RoleDto) {
  }
}

export class AddPermissionToRole implements Action {
  readonly type = RoleActionTypes.AddPermissionToRole;

  constructor(public payload: PermissionDto) {
  }
}

export class RemovePermissionFromRole implements Action {
  readonly type = RoleActionTypes.RemovePermissionFromRole;

  constructor(public payload: RoleDto) {
  }
}

export type RoleActions =
  InitPermissions |
  AddRole |
  DeleteRole |
  UpdateRole |
  ChangeApplication;
